import { useEffect } from "react";

const ConfirmDialog = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  cancelVisible = true,
  buttonText = "",
  language = false,
}) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onCancel();
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
    }
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-xl shadow-xl p-8 w-[420px] min-h-[220px] flex flex-col justify-between">
        <h2 className="text-xl font-bold text-center mb-4">
          {typeof title === "object"
            ? language
              ? title.hi
              : title.en
            : title || (language ? "पुष्टि करें" : "Confirm")}
        </h2>
        <p className="text-center text-lg mb-8">
          {typeof message === "object"
            ? language
              ? message.hi
              : message.en
            : message ||
              (language ? "क्या आप सुनिश्चित हैं?" : "Are you sure?")}
        </p>
        <div className="flex justify-center space-x-4">
          {cancelVisible && (
            <button
              onClick={onCancel}
              className="px-5 py-2 text-base bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
            >
              {language ? "नहीं" : "No"}
            </button>
          )}
          <button
            onClick={onConfirm}
            className="px-5 py-2 text-base bg-red-500 text-white rounded-lg hover:bg-red-600"
          >
            {typeof buttonText === "object"
              ? language
                ? buttonText.hi
                : buttonText.en
              : buttonText || (language ? "हाँ" : "Yes")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
